(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boxiv-announcement-rotator"] && !Shopify.designMode) return;
  try {
    
  class BoxivAnnouncementRotator extends HTMLElement {
    #timer = null;
    #current = 0;

    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-message]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.interval = parseInt(this.dataset.interval, 10) || 4000;

      if (this.messages.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const i = parseInt(dot.dataset.index, 10);
          this.go(i, true);
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.#timer = window.setInterval(() => this.go(this.#current + 1), this.interval);
    }

    stop() {
      if (this.#timer) {
        window.clearInterval(this.#timer);
        this.#timer = null;
      }
    }

    go(index, restart) {
      const len = this.messages.length;
      const i = ((index % len) + len) % len;
      this.#current = i;

      this.messages.forEach((msg, idx) => {
        if (idx === i) {
          msg.removeAttribute('aria-hidden');
        } else {
          msg.setAttribute('aria-hidden', 'true');
        }
      });

      this.dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === i);
        dot.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });

      if (restart) this.start();
    }
  }

  if (!customElements.get('boxiv-announcement-rotator')) {
    customElements.define('boxiv-announcement-rotator', BoxivAnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-campaign-carousel"] && !Shopify.designMode) return;
  try {
    
  class BoxivCampaignCards extends HTMLElement {
    #onScroll = null;
    #onSelect = null;
    #observer = null;

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track) return;

      this.#onScroll = () => this.#update();
      this.track.addEventListener('scroll', this.#onScroll, { passive: true });
      this.#observer = new ResizeObserver(() => this.#update());
      this.#observer.observe(this.track);

      this.prevBtn?.addEventListener('click', () => this.#step(-1));
      this.nextBtn?.addEventListener('click', () => this.#step(1));

      // テーマエディタでブロックを選んだら、そのカードまでスクロールする
      this.#onSelect = (event) => {
        if (!this.contains(event.target)) return;
        event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      };
      document.addEventListener('shopify:block:select', this.#onSelect);

      this.#update();
    }

    disconnectedCallback() {
      if (this.#onScroll) this.track?.removeEventListener('scroll', this.#onScroll);
      if (this.#onSelect) document.removeEventListener('shopify:block:select', this.#onSelect);
      this.#observer?.disconnect();
    }

    #step(direction) {
      const item = this.track.querySelector('[data-item]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const width = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * width, behavior: reduce ? 'auto' : 'smooth' });
    }

    #update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const none = max <= 1;
      this.#setDisabled(this.prevBtn, none || t.scrollLeft <= 1);
      this.#setDisabled(this.nextBtn, none || t.scrollLeft >= max - 1);
    }

    #setDisabled(btn, disabled) {
      if (!btn) return;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      btn.tabIndex = disabled ? -1 : 0;
    }
  }

  if (!customElements.get('boxiv-campaign-cards')) {
    customElements.define('boxiv-campaign-cards', BoxivCampaignCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-cart-recommends"]) return;
  try {
    
  (() => {
    if (window.__bxRecsInit) return;
    window.__bxRecsInit = true;

    // Delegated arrow controls (shared with boxiv-pdp-recommends; only one runs per page).
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bx-rec-prev], [data-bx-rec-next]');
      if (!btn) return;
      const pr = btn.closest('.bx-recs__pr');
      const track = pr && pr.querySelector('[data-bx-rec-track]');
      if (!track) return;
      const card = track.querySelector('.bx-recs__card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: btn.matches('[data-bx-rec-next]') ? step : -step, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-mega-nav"] && !Shopify.designMode) return;
  try {
    
  const BOXIV_MEGANAV_MOBILE_QUERY = '(max-width: 989px)';

  class BoxivMegaNav extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.panel = this.querySelector('[data-panel]');
      this.toggles = Array.from(this.querySelectorAll('[data-toggle]'));
      this.mq = window.matchMedia(BOXIV_MEGANAV_MOBILE_QUERY);

      // Where the panel lives when it is not hoisted into Dawn's header.
      this.home = this.panel?.parentElement || this;

      this.onResize = () => {
        this.#syncPlacement();
        this.#syncTriggerPosition();
        this.#syncDropOffset();
        this.#syncMode();
      };
      this.onScroll = () => this.#syncTriggerPosition();
      this.onDocumentKeydown = (event) => this.#handleDocumentKeydown(event);
      // PC 幅: ナビの外をタップ・クリックしたら開いているサブメニューを閉じる。タッチでは pointerleave で
      // 閉じず、Safari はタップでボタンにフォーカスしない（focusout も来ない）ので、これが無いとタップで
      // 開いたサブメニューは見出しをもう一度タップするまで開きっぱなしになる（D-31 の修正に伴う）
      this.onDocumentPointerdown = (event) => {
        if (this.#isMobile) return;
        if (event.target instanceof Node && this.panel?.contains(event.target)) return;
        this.#closeAllSubmenus();
      };
      /** SP メニューを開いている間に、この要素が inert にした要素（閉じるときに戻す） */
      this.inerted = [];

      this.#syncPlacement();
      this.#syncTriggerPosition();
      this.#syncDropOffset();
      this.#syncMode();

      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('keydown', this.onDocumentKeydown);
      document.addEventListener('pointerdown', this.onDocumentPointerdown);
      this.mq.addEventListener('change', this.onResize);

      this.trigger?.addEventListener('click', () => this.#toggleMenu());

      for (const toggle of this.toggles) {
        const item = toggle.closest('[data-item]');
        toggle.addEventListener('click', (event) => this.#handleToggleClick(event, toggle));
        toggle.addEventListener('keydown', (event) => this.#handleToggleKeydown(event, toggle));
        if (!item) continue;
        // PC 幅のホバーで開く動きは、本物のマウスのときだけにする。タッチとペンは click に任せる。
        // ⚠️ mouseenter は使わない: タッチの 1 回目のタップでも互換イベントとして発火してサブメニューを開き、
        //    直後の click がそれを閉じていた。990px 以上のタッチ端末で 1 回目のタップが効かなかった原因（D-31）
        // ⚠️ matchMedia('(hover: hover) and (pointer: fine)') でも直らない: タッチ対応の Windows ノートでは
        //    true になり、指で触ると同じ不具合が起きる
        item.addEventListener('pointerenter', (event) => {
          if (this.#isMobile || event.pointerType !== 'mouse') return;
          toggle.dataset.hoverOpen = 'true';
          this.#setSubmenu(toggle, true);
        });
        item.addEventListener('pointerleave', (event) => {
          if (this.#isMobile || event.pointerType !== 'mouse') return;
          this.#setSubmenu(toggle, false);
        });
        item.addEventListener('focusout', (event) => {
          if (this.#isMobile) return;
          if (item.contains(event.relatedTarget)) return;
          this.#setSubmenu(toggle, false);
        });
      }

      // Close the mobile overlay after tapping through to a page.
      for (const link of this.querySelectorAll('a[href]')) {
        link.addEventListener('click', () => {
          if (this.dataset.open === 'true') this.#closeMenu();
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onDocumentKeydown);
      document.removeEventListener('pointerdown', this.onDocumentPointerdown);
      this.mq.removeEventListener('change', this.onResize);
      // テーマエディタの再描画などで外されたとき、ページを inert のまま残さない
      this.#setBackgroundInert(false);
      // The hoisted panel lives outside this section, so it survives a section re-render in the
      // theme editor and would pile up a duplicate nav on every save. Take it with us.
      if (this.panel?.isConnected && !this.contains(this.panel)) this.panel.remove();
    }

    get #isMobile() {
      return this.mq.matches;
    }

    /**
     * Desktop: move the panel into Dawn's header so the links sit right of the logo.
     * Mobile: move it back, because Dawn hides that slot below 990px and the overlay
     * would be hidden with it.
     *
     * Deliberately fail-visible. `data-hoisted` only flips to "true" after the panel is
     * actually inside the header, and the standalone bar stays styled until then — the
     * previous implementation assumed the move worked and left the nav at 0x0 when it didn't.
     */
    #syncPlacement() {
      if (!this.panel) return;

      if (this.#isMobile) {
        if (this.panel.parentElement !== this.home) this.home.appendChild(this.panel);
        this.panel.classList.remove('boxiv-meganav__panel--hoisted');
        this.dataset.hoisted = 'false';
        return;
      }

      // `.header__inline-menu` is Dawn's own `navigation` grid area, already breakpoint-aware.
      // It only exists when a navigation menu is assigned to the header section, so fall back
      // to the header element itself and claim the same grid area by hand.
      const slot = document.querySelector('.header__inline-menu');
      const header = document.querySelector('.header-wrapper .header, .header');

      if (slot) {
        if (this.panel.parentElement !== slot) slot.appendChild(this.panel);
      } else if (header) {
        if (this.panel.parentElement !== header) header.appendChild(this.panel);
        const areas = getComputedStyle(header).gridTemplateAreas;
        this.panel.style.gridArea = areas.includes('navigation') ? 'navigation' : '';
      } else {
        // No header to attach to — keep rendering the standalone bar rather than vanishing.
        this.panel.classList.remove('boxiv-meganav__panel--hoisted');
        this.dataset.hoisted = 'false';
        return;
      }

      this.panel.classList.add('boxiv-meganav__panel--hoisted');
      this.dataset.hoisted = 'true';
    }

    /**
     * Keeps the desktop bar and the mobile overlay from leaking state into each other.
     */
    #syncMode() {
      if (this.#isMobile) {
        this.panel?.setAttribute('aria-hidden', this.dataset.open === 'true' ? 'false' : 'true');
        if (this.panel) this.panel.inert = this.dataset.open !== 'true';
        return;
      }
      // Desktop: the bar is always visible, so it must never be hidden from assistive tech.
      this.panel?.removeAttribute('aria-hidden');
      if (this.panel) this.panel.inert = false;
      // SP で開いたまま PC 幅に広げたとき、背面の inert を残さない
      this.#setBackgroundInert(false);
      if (this.dataset.open === 'true') {
        this.dataset.open = 'false';
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.trigger?.setAttribute('aria-label', 'メニューを開く');
      }
      this.#closeAllSubmenus();
    }

    /** Distance from the bottom of the nav row to the bottom of Dawn's header. */
    #syncDropOffset() {
      if (this.#isMobile || this.dataset.hoisted !== 'true' || !this.panel) return;
      const header = document.querySelector('.header-wrapper .header, .header');
      const list = this.panel.querySelector('.boxiv-meganav__list');
      if (!header || !list) return;
      const gap = header.getBoundingClientRect().bottom - list.getBoundingClientRect().bottom;
      this.panel.style.setProperty('--bx-nav-drop-offset', `${Math.max(0, Math.round(gap))}px`);
    }

    #syncTriggerPosition() {
      if (!this.#isMobile) return;
      const headerEl =
        document.querySelector('sticky-header') ||
        document.querySelector('.header-wrapper .header') ||
        document.querySelector('.section-header .header') ||
        document.querySelector('.shopify-section-group-header-group .header');
      if (!headerEl) return;
      const rect = headerEl.getBoundingClientRect();
      this.style.setProperty('--boxiv-nav-top', `${Math.max(rect.top, 0)}px`);
      this.style.setProperty('--boxiv-nav-height', `${rect.height}px`);
    }

    #toggleMenu() {
      if (this.dataset.open === 'true') this.#closeMenu();
      else this.#openMenu();
    }

    #openMenu() {
      this.dataset.open = 'true';
      if (this.panel) this.panel.inert = false;
      this.trigger?.setAttribute('aria-expanded', 'true');
      this.trigger?.setAttribute('aria-label', 'メニューを閉じる');
      this.panel?.setAttribute('aria-hidden', 'false');
      // 開いている間は背面を inert にして、Tab とスクリーンリーダーをメニューの中に留める（D-30）
      if (this.#isMobile) this.#setBackgroundInert(true);
      setTimeout(() => {
        const first = this.panel?.querySelector('a, button');
        first?.focus({ preventScroll: true });
      }, 360);
    }

    #closeMenu() {
      this.dataset.open = 'false';
      // フェードアウト（0.35 秒）の間も Tab で入れないよう、すぐ inert にする（visibility の切り替えは遅れて来る）
      if (this.panel && this.#isMobile) this.panel.inert = true;
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.trigger?.setAttribute('aria-label', 'メニューを開く');
      this.panel?.setAttribute('aria-hidden', 'true');
      this.#setBackgroundInert(false);
      this.#closeAllSubmenus();
      this.trigger?.focus({ preventScroll: true });
    }

    /**
     * SP メニューを開いている間、この要素の外側をすべて inert にする（on=false で元に戻す）。
     * この要素から <body> まで親をたどり、途中の兄弟要素に付けるので、ヘッダーグループの包み方に依存しない。
     * トリガーとパネルはこの要素の子なので操作できるまま残る。
     * 戻すのは自分が付けたものだけ（もともと inert だった要素＝閉じたドロワーやアプリのモーダルには触らない）。
     * @param {boolean} on
     */
    #setBackgroundInert(on) {
      for (const el of this.inerted) el.inert = false;
      this.inerted = [];
      if (!on) return;
      const skip = new Set(['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE', 'NOSCRIPT']);
      let node = this;
      while (node.parentElement && node !== document.body) {
        for (const sibling of node.parentElement.children) {
          if (sibling === node || sibling.inert || skip.has(sibling.tagName)) continue;
          sibling.inert = true;
          this.inerted.push(sibling);
        }
        node = node.parentElement;
      }
    }

    #closeAllSubmenus() {
      for (const toggle of this.toggles) this.#setSubmenu(toggle, false);
    }

    /**
     * @param {HTMLElement} toggle - the group button
     * @param {boolean} open - desired state
     */
    #setSubmenu(toggle, open) {
      const sublist = this.#sublistFor(toggle);
      if (!sublist) return;
      if (!open) delete toggle.dataset.hoverOpen;
      if (toggle.getAttribute('aria-expanded') === String(open)) return;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        // Re-measure on open: the logo is an image, so the header height can settle after load.
        this.#syncDropOffset();
        sublist.removeAttribute('hidden');
      } else sublist.setAttribute('hidden', '');
    }

    #sublistFor(toggle) {
      // Looked up from the document, not from `this` — once hoisted the panel is a child of
      // Dawn's header and is no longer a descendant of this element.
      const id = toggle.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    #handleToggleClick(event, toggle) {
      // The group label is a button, not a link — nothing to navigate to.
      event.preventDefault();
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      // マウスのホバーで開いた直後のクリックは「開く」の続きとして扱い、閉じない。
      // 印はここで使い切るので、次のクリックからは通常どおり開閉する
      if (!this.#isMobile && isOpen && toggle.dataset.hoverOpen === 'true') {
        delete toggle.dataset.hoverOpen;
        return;
      }
      if (!this.#isMobile && !isOpen) this.#closeAllSubmenus();
      this.#setSubmenu(toggle, !isOpen);
    }

    #handleToggleKeydown(event, toggle) {
      // Enter/Space already fire click on a <button>; only arrow keys need wiring.
      if (event.key !== 'ArrowDown' || this.#isMobile) return;
      event.preventDefault();
      this.#closeAllSubmenus();
      this.#setSubmenu(toggle, true);
      this.#sublistFor(toggle)?.querySelector('a')?.focus({ preventScroll: true });
    }

    #handleDocumentKeydown(event) {
      if (event.key !== 'Escape') return;
      if (this.dataset.open === 'true') {
        this.#closeMenu();
        return;
      }
      const openToggle = this.toggles.find(
        (toggle) => toggle.getAttribute('aria-expanded') === 'true'
      );
      if (!openToggle) return;
      this.#setSubmenu(openToggle, false);
      openToggle.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('boxiv-mega-nav')) {
    customElements.define('boxiv-mega-nav', BoxivMegaNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-pdp-ambient"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* ---------------- color helpers ---------------- */
    const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

    const rgbToHsl = (r, g, b) => {
      r /= 255; g /= 255; b /= 255;
      const max = Math.max(r, g, b), min = Math.min(r, g, b);
      let h = 0;
      const l = (max + min) / 2;
      const d = max - min;
      const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
      if (d !== 0) {
        if (max === r) h = ((g - b) / d) % 6;
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h *= 60;
        if (h < 0) h += 360;
      }
      return [h, s, l];
    };

    const hslToCss = (h, s, l) =>
      `hsl(${Math.round((h % 360 + 360) % 360)}, ${Math.round(clamp(s, 0, 1) * 100)}%, ${Math.round(clamp(l, 0, 1) * 100)}%)`;

    // A cohesive light-theme wash: one dominant hue rendered as a soft analogous triad.
    // Keeps fidelity to the image while staying subtle (no clashing complementary pairs).
    const analogTriad = (h, s) => {
      const S = clamp(s, 0.32, 0.72);
      return [
        hslToCss(h - 18, S * 0.92, 0.84),
        hslToCss(h, S, 0.8),
        hslToCss(h + 22, S * 0.88, 0.83),
      ];
    };

    /* ---------------- dominant-color sampler ---------------- */
    const SAMPLE = 48;
    const canvas = document.createElement('canvas');
    canvas.width = SAMPLE;
    canvas.height = SAMPLE;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });

    const colorsFromDrawable = (drawable) => {
      try {
        // Re-assigning width resets the bitmap AND the canvas origin-clean flag.
        // Critical: drawing a cross-origin <video> taints the canvas, and clearRect
        // does NOT clear that taint — without this reset, one video would break
        // getImageData for every subsequent image sample on the page.
        canvas.width = SAMPLE;
        ctx.drawImage(drawable, 0, 0, SAMPLE, SAMPLE);
        const data = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
        const BUCKETS = 18;
        const buckets = Array.from({ length: BUCKETS }, () => ({ w: 0, r: 0, g: 0, b: 0 }));
        const base = { r: 0, g: 0, b: 0, n: 0 };
        let sat = 0;
        for (let i = 0; i < data.length; i += 4) {
          const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
          if (a < 128) continue;
          base.r += r; base.g += g; base.b += b; base.n++;
          const [h, s, l] = rgbToHsl(r, g, b);
          if (s < 0.18 || l < 0.1 || l > 0.92) continue; // skip gray / near-white / near-black
          const bi = Math.min(BUCKETS - 1, Math.floor((h / 360) * BUCKETS));
          const w = s * (1 - Math.abs(l - 0.5)); // weight vivid mid-tones
          buckets[bi].w += w;
          buckets[bi].r += r * w;
          buckets[bi].g += g * w;
          buckets[bi].b += b * w;
          sat += s;
        }
        // Dominant hue = the single most prominent colour family (mode, not mean —
        // avoids two opposite hues cancelling or clashing).
        let top = null;
        for (const bk of buckets) {
          if (bk.w > 0 && (!top || bk.w > top.w)) top = bk;
        }
        if (top) {
          const [h, s] = rgbToHsl(top.r / top.w, top.g / top.w, top.b / top.w);
          return analogTriad(h, clamp(s * 1.2, 0.34, 0.72));
        }
        // Near-neutral image → barely-tinted soft wash from the average pixel.
        if (base.n > 0) {
          const [h, s] = rgbToHsl(base.r / base.n, base.g / base.n, base.b / base.n);
          return analogTriad(h, clamp(s * 1.4, 0.1, 0.3));
        }
        return null;
      } catch (e) {
        return null; // tainted or unavailable
      }
    };

    const sampleUrlOf = (imgEl) => {
      const raw = imgEl.currentSrc || imgEl.getAttribute('src');
      if (!raw) return null;
      try {
        const u = new URL(raw, location.href);
        u.searchParams.set('width', '96');
        return u.toString();
      } catch (e) {
        return raw;
      }
    };

    const urlCache = new Map();
    const sampleImage = (url) =>
      new Promise((resolve) => {
        if (urlCache.has(url)) return resolve(urlCache.get(url));
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.onload = () => {
          const cols = colorsFromDrawable(img);
          urlCache.set(url, cols);
          resolve(cols);
        };
        img.onerror = () => resolve(null);
        img.src = url;
      });

    /* ---------------- engine ---------------- */
    const S = { current: null, io: null, revealIo: null, buyboxCleanup: null };

    const initAmbient = () => {
      const layer = document.querySelector('[data-bx-ambient-layer]');
      if (!layer) return;
      document.documentElement.classList.add('bx-js');

      // Tear down a previous run so shopify:section:load (Theme Editor) re-inits
      // don't stack duplicate observers / scroll listeners.
      if (S.io) S.io.disconnect();
      if (S.revealIo) S.revealIo.disconnect();
      if (S.buyboxCleanup) S.buyboxCleanup();
      S.io = S.revealIo = S.buyboxCleanup = null;

      const targets = Array.from(document.querySelectorAll('[data-bx-ambient]'));

      const applyColors = (cols) => {
        if (!cols || !cols.length) return;
        layer.style.setProperty('--bx-amb-a', cols[0]);
        layer.style.setProperty('--bx-amb-b', cols[1] || cols[0]);
        layer.style.setProperty('--bx-amb-c', cols[2] || cols[cols.length - 1]);
      };

      const applyFromDataset = (target) => {
        const parts = (target.dataset.bxAmbient || '').split('|').map((s) => s.trim()).filter(Boolean);
        if (parts.length) applyColors(parts);
      };

      // The foreground media element that should drive the background for a section.
      const mediaElOf = (target) => {
        if (target.matches('[data-bx-buybox]')) {
          const track = target.querySelector('[data-bx-track]');
          const slides = target.querySelectorAll('[data-bx-slide]');
          if (track && slides.length) {
            const idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            const slide = slides[Math.min(idx, slides.length - 1)] || slides[0];
            return slide.querySelector('img:not(.placeholder), video');
          }
        }
        return target.querySelector('img:not(.placeholder), video');
      };

      const activate = (target) => {
        S.current = target;
        const el = mediaElOf(target);
        if (!el) return; // no media → hold the previous background (statements, back link)

        if (el.tagName === 'VIDEO') {
          const sampleVideo = () => {
            const cols = colorsFromDrawable(el);
            if (cols && S.current === target) applyColors(cols);
            else if (!cols) applyFromDataset(target);
          };
          if (el.readyState >= 2) {
            sampleVideo();
          } else {
            applyFromDataset(target); // fallback until the first frame is decodable
            el.addEventListener('loadeddata', () => { if (S.current === target) sampleVideo(); }, { once: true });
          }
          return;
        }

        const url = sampleUrlOf(el);
        if (!url) { applyFromDataset(target); return; }
        target.__bxUrl = url; // latest URL requested for this section
        if (urlCache.has(url)) {
          const cached = urlCache.get(url);
          if (cached) { applyColors(cached); return; }
          applyFromDataset(target); // previously sampled and failed → fallback
          return;
        }
        applyFromDataset(target); // configured fallback while we sample
        sampleImage(url).then((cols) => {
          // Guard on the active section AND the latest requested URL so a stale gallery
          // slide's late-resolving sample can't overwrite the current one.
          if (cols && S.current === target && target.__bxUrl === url) applyColors(cols);
        });
      };

      if ('IntersectionObserver' in window && targets.length) {
        S.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) activate(entry.target);
            });
          },
          { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
        );
        targets.forEach((t) => S.io.observe(t));
        activate(targets[0]);

        // Buy box: follow the currently visible gallery image as the user swipes / switches variant.
        const buybox = document.querySelector('[data-bx-buybox]');
        const track = buybox && buybox.querySelector('[data-bx-track]');
        if (buybox && track) {
          let raf = null;
          const refresh = () => {
            raf = null;
            if (S.current === buybox) activate(buybox);
          };
          const onScroll = () => {
            if (raf) return;
            raf = requestAnimationFrame(refresh);
          };
          track.addEventListener('scroll', onScroll, { passive: true });
          S.buyboxCleanup = () => track.removeEventListener('scroll', onScroll);
        }
      } else if (targets.length) {
        applyFromDataset(targets[0]);
      }

      /* ---------------- reveal on scroll (text + media) ---------------- */
      const revealTargets = document.querySelectorAll('.bx-reveal:not(.bx-in), .bx-mrev:not(.bx-in)');
      if (revealTargets.length && 'IntersectionObserver' in window) {
        S.revealIo = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('bx-in');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
        );
        revealTargets.forEach((t) => S.revealIo.observe(t));
      } else {
        revealTargets.forEach((t) => t.classList.add('bx-in'));
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAmbient);
    } else {
      initAmbient();
    }

    document.addEventListener('shopify:section:load', initAmbient);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBuyboxes = () => {
      document.querySelectorAll('[data-bx-buybox]:not([data-bx-ready])').forEach((root) => {
        root.setAttribute('data-bx-ready', 'true');

        /* --- 長い説明の折りたたみ（D-19） --- */
        const descWrap = root.querySelector('[data-bx-desc]');
        if (descWrap) {
          const desc = descWrap.querySelector('.bx-buy__desc');
          const more = descWrap.querySelector('.bx-buy__desc-more');
          const limit = parseFloat(getComputedStyle(desc).fontSize) * 12;
          // 少しだけはみ出す程度なら畳まない（「続きを読む」で 1〜2 行しか増えないのは煩わしい）
          if (desc && more && desc.scrollHeight > limit * 1.35) {
            descWrap.classList.add('is-collapsed');
            more.hidden = false;
            const expand = () => {
              descWrap.classList.remove('is-collapsed');
              more.setAttribute('aria-expanded', 'true');
              more.hidden = true;
            };
            more.addEventListener('click', () => {
              expand();
              // ボタンは消えるので、フォーカスを説明の先頭へ移す（行き場を失って <body> に飛ばないように）
              desc.setAttribute('tabindex', '-1');
              desc.focus({ preventScroll: true });
            });
            // 畳んだ部分のリンクに Tab で入ったら開く（見えない場所にフォーカスが行かないように）
            desc.addEventListener('focusin', expand, { once: true });
          }
        }

        /* --- Gallery --- */
        const track = root.querySelector('[data-bx-track]');
        const slides = root.querySelectorAll('[data-bx-slide]');
        const counter = root.querySelector('[data-bx-counter]');
        const goTo = (index) => {
          if (!track || !slides.length) return;
          const i = Math.max(0, Math.min(index, slides.length - 1));
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        };
        if (track && slides.length > 1) {
          const currentIndex = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          const prev = root.querySelector('[data-bx-prev]');
          const next = root.querySelector('[data-bx-next]');
          if (prev) prev.addEventListener('click', () => goTo(currentIndex() - 1));
          if (next) next.addEventListener('click', () => goTo(currentIndex() + 1));
          if (counter) {
            let raf = null;
            track.addEventListener('scroll', () => {
              if (raf) return;
              raf = requestAnimationFrame(() => {
                raf = null;
                counter.textContent = `${currentIndex() + 1} / ${slides.length}`;
              });
            });
          }
        }

        /* --- スティッキー島（SP は画面下、PC は右上） ---
           表示はフォーム（数量〜今すぐ購入）が画面上端を越えたときだけ。非表示中は inert（監査 D-16）。
           - IntersectionObserver は交差の有無が変わったときしか呼ばれず、Home / End やアンカーで一気に
             移動すると島の状態が更新されない（I-24）。scroll と resize でも位置から判定し直す
           - PC ではカート追加の通知（#cart-notification、右上）が島の下に隠れ、閉じるボタンが押せなかった。
             通知が開いている間は島を引っ込める
           - 実ボタンの読み込み中（product-form.js が .loading を付ける）は、島のボタンも aria-busy にする（D-17） */
        const stickyBar = root.querySelector('[data-bx-sticky]');
        const anchorBtn = root.querySelector('.bx-buy__submit');
        const stickyAdd = root.querySelector('[data-bx-sticky-add]');
        const stickyShown = () => !!stickyBar && stickyBar.classList.contains('bx-in');
        if (stickyBar && anchorBtn) {
          // <product-form> は display 未指定のインライン要素で箱が当てにならないので、中の <form>
          // （display:grid。数量・カート追加・今すぐ購入をすべて含む）の位置で判定する
          const watchEl = root.querySelector('.bx-buy__form form') || anchorBtn;
          const notif = document.getElementById('cart-notification');
          const pcQuery = window.matchMedia('(min-width: 990px)');
          const applyIsland = () => {
            const passed = watchEl.getBoundingClientRect().bottom < 0;
            const notifOpen = !!notif && pcQuery.matches && notif.classList.contains('active');
            const show = passed && !notifOpen;
            stickyBar.classList.toggle('bx-in', show);
            stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
            stickyBar.inert = !show;
          };
          let islandRaf = 0;
          const scheduleIsland = () => {
            if (islandRaf) return;
            islandRaf = requestAnimationFrame(() => {
              islandRaf = 0;
              applyIsland();
            });
          };
          window.addEventListener('scroll', scheduleIsland, { passive: true });
          window.addEventListener('resize', scheduleIsland, { passive: true });
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(scheduleIsland, { threshold: 0 }).observe(watchEl);
          }
          // 島のボタンから追加したか。通知を閉じたときにフォーカスを島へ戻すのに使う
          let islandSubmitted = false;
          if (notif) {
            let notifWasOpen = notif.classList.contains('active');
            new MutationObserver(() => {
              const open = notif.classList.contains('active');
              if (notifWasOpen && !open) {
                // 通知が閉じた。cart-notification.js は閉じた直後に送信元（島のボタン）へフォーカスを戻そうとするが、
                // その時点の島はまだ inert なので戻らず <body> に落ちていた。ここで島を同期で出し直し、フォーカスを戻す
                applyIsland();
                const lost = document.activeElement === document.body || notif.contains(document.activeElement);
                if (islandSubmitted && stickyAdd && stickyShown() && lost) stickyAdd.focus({ preventScroll: true });
                islandSubmitted = false;
              } else {
                scheduleIsland();
              }
              notifWasOpen = open;
            }).observe(notif, { attributes: true, attributeFilter: ['class'] });
          }
          applyIsland();

          if (stickyAdd) {
            stickyAdd.addEventListener('click', () => {
              if (!stickyShown() || anchorBtn.hasAttribute('disabled')) return;
              islandSubmitted = true;
              anchorBtn.click(); // proxy to the real submit button → product-form.js
            });
            new MutationObserver(() => {
              stickyAdd.setAttribute('aria-busy', anchorBtn.classList.contains('loading') ? 'true' : 'false');
            }).observe(anchorBtn, { attributes: true, attributeFilter: ['class'] });
          }
        }

        /* --- カート追加の失敗（在庫超過で一部だけ入った 422 など。監査 D-17） ---
           product-form.js はエラー文を出すだけで、カート数も通知も更新しない。
           (1) 一部は入っていることがあるので、ヘッダーのカート数を描き直す
           (2) 島から押したときはエラー欄が画面外にあるので、画面内へ出す */
        const refreshCartBubble = () => {
          const bubble = document.getElementById('cart-icon-bubble');
          if (!bubble) return;
          const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(`${base}?sections=cart-icon-bubble`)
            .then((res) => res.json())
            .then((json) => {
              const html = json && json['cart-icon-bubble'];
              if (!html) return;
              const sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (sec) bubble.innerHTML = sec.innerHTML;
            })
            .catch(() => {});
        };
        const onCartError = (event) => {
          const idEl = root.querySelector('[data-bx-variant-id]');
          if (!event || event.source !== 'product-form' || !idEl || String(event.productVariantId) !== String(idEl.value)) return;
          const fromIsland = stickyShown();
          refreshCartBubble();
          // エラー文は publish の直後に product-form.js が入れるので、少し待ってから見る
          setTimeout(() => {
            const err = root.querySelector('.bx-buy__error');
            if (!fromIsland || !err || err.hasAttribute('hidden')) return;
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            err.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          }, 60);
        };
        const subscribeCartError = () => {
          if (root.dataset.bxCartErrorBound) return true;
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartError) return false;
          subscribe(PUB_SUB_EVENTS.cartError, onCartError);
          root.dataset.bxCartErrorBound = 'true';
          return true;
        };
        // pubsub.js は defer。読み込み順が変わっても取りこぼさないよう、足りなければ後で登録する
        if (!subscribeCartError()) {
          document.addEventListener('DOMContentLoaded', subscribeCartError, { once: true });
          window.addEventListener('load', subscribeCartError, { once: true });
        }

        /* --- Variant picker --- */
        const variantsEl = root.querySelector('[data-bx-variants]');
        if (!variantsEl) return;
        let variants = [];
        try {
          variants = JSON.parse(variantsEl.textContent);
        } catch (e) {
          return;
        }

        const inputs = Array.from(root.querySelectorAll('[data-bx-option-input]'));
        const priceEl = root.querySelector('[data-bx-price]');
        const compareEl = root.querySelector('[data-bx-compare]');
        const idInput = root.querySelector('[data-bx-variant-id]');
        const submitBtn = root.querySelector('.bx-buy__submit');
        const submitLabel = root.querySelector('[data-bx-submit-label]');
        const stickyPrice = root.querySelector('[data-bx-sticky-price]');
        const stickyLabel = root.querySelector('[data-bx-sticky-label]');
        const stickyBtn = root.querySelector('[data-bx-sticky-add]');
        const dynamicEl = root.querySelector('[data-bx-dynamic]');
        const qtyInput = root.querySelector('.bx-buy__qty input[name="quantity"]');
        const strings = window.variantStrings || {};

        // 数量ルール（min / max / increment）はバリアントごとに違いうる。Dawn の updateQuantityRules と同じ考え方
        const applyQtyRules = (q) => {
          if (!qtyInput || !q) return;
          qtyInput.min = q.min;
          qtyInput.dataset.min = q.min;
          qtyInput.step = q.inc;
          if (q.max != null) {
            qtyInput.max = q.max;
            qtyInput.dataset.max = q.max;
          } else {
            qtyInput.removeAttribute('max');
            delete qtyInput.dataset.max;
          }
          const v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < q.min || (q.max != null && v > q.max) || (v - q.min) % q.inc !== 0) {
            qtyInput.value = q.min;
          }
          qtyInput.dispatchEvent(new Event('change', { bubbles: true })); // QuantityInput.validateQtyRules を動かす
        };

        const selectedOptions = () => {
          const sel = [];
          inputs.forEach((input) => {
            if (input.checked) sel[Number(input.dataset.optionIndex)] = input.value;
          });
          return sel;
        };

        const findVariant = (sel) =>
          variants.find((v) => v.options.every((opt, i) => opt === sel[i]));

        const markAvailability = (sel) => {
          inputs.forEach((input) => {
            const i = Number(input.dataset.optionIndex);
            const hypothetical = sel.slice();
            hypothetical[i] = input.value;
            const match = variants.find(
              (v) => v.options.every((opt, j) => j === i ? opt === input.value : opt === hypothetical[j])
            );
            input.closest('.bx-pill').classList.toggle('bx-pill--unavailable', !match || !match.available);
          });
        };

        const update = () => {
          const sel = selectedOptions();
          const variant = findVariant(sel);
          markAvailability(sel);

          if (!variant) {
            if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
            if (submitLabel) submitLabel.textContent = strings.unavailable || 'Unavailable';
            if (stickyBtn) stickyBtn.setAttribute('disabled', 'disabled');
            if (stickyLabel) stickyLabel.textContent = strings.unavailable || 'Unavailable';
            if (dynamicEl) dynamicEl.classList.add('hidden');
            return;
          }

          if (priceEl) priceEl.textContent = variant.price;
          if (stickyPrice) stickyPrice.textContent = variant.price;
          if (compareEl) {
            compareEl.textContent = variant.compare || '';
            compareEl.classList.toggle('hidden', !variant.compare);
          }
          if (idInput) {
            idInput.value = variant.id;
            idInput.disabled = !variant.available;
            // Shopify の決済ボタンはフォームの change でバリアントを読み直す（Dawn の product-info.js と同じ）
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (dynamicEl) dynamicEl.classList.toggle('hidden', !variant.available);
          applyQtyRules(variant.qty);
          if (submitBtn && submitLabel) {
            if (variant.available) {
              submitBtn.removeAttribute('disabled');
              submitLabel.textContent = strings.addToCart || 'Add to cart';
            } else {
              submitBtn.setAttribute('disabled', 'disabled');
              submitLabel.textContent = strings.soldOut || 'Sold out';
            }
          }
          if (stickyBtn && stickyLabel) {
            if (variant.available) {
              stickyBtn.removeAttribute('disabled');
              stickyLabel.textContent = strings.addToCart || 'Add to cart';
            } else {
              stickyBtn.setAttribute('disabled', 'disabled');
              stickyLabel.textContent = strings.soldOut || 'Sold out';
            }
          }

          if (variant.media > 0) goTo(variant.media - 1);

          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {
            /* noop */
          }
        };

        inputs.forEach((input) => input.addEventListener('change', update));
        markAvailability(selectedOptions());

        // ?variant= で着地したとき、ギャラリーをそのバリアントの画像に合わせる（監査 D-18）。
        // track には CSS の scroll-behavior:smooth があるので、一時的に auto にして即座に移す
        const initialVariant = idInput && variants.find((v) => String(v.id) === String(idInput.value));
        if (initialVariant && initialVariant.media > 1 && track && slides.length > 1) {
          const jumpToInitial = () => {
            const i = Math.min(initialVariant.media - 1, slides.length - 1);
            const prev = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = i * track.clientWidth;
            track.style.scrollBehavior = prev;
            if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
          };
          if (track.clientWidth) jumpToInitial();
          else requestAnimationFrame(jumpToInitial);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBuyboxes);
    } else {
      initBuyboxes();
    }

    document.addEventListener('shopify:section:load', initBuyboxes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-pdp-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChips = () => {
      document.querySelectorAll('[data-bx-chips]:not([data-bx-ready])').forEach((wrap) => {
        wrap.setAttribute('data-bx-ready', 'true');
        const label = wrap.querySelector('[data-bx-chip-label]');
        const chips = wrap.querySelectorAll('[data-bx-chip]');
        chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            chips.forEach((c) => {
              c.classList.remove('bx-feature__chip--active');
              c.setAttribute('aria-pressed', 'false');
            });
            chip.classList.add('bx-feature__chip--active');
            chip.setAttribute('aria-pressed', 'true');
            if (label) label.textContent = chip.dataset.chipLabel;
          });
        });
      });
    };

    /* スライドショー: 一定間隔で次の写真へ。画面に入っている・タブが表に出ている・
       止められていない、の 3 つがそろったときだけ進める。動きを減らす設定の人には
       自動で進めず、再生ボタンの状態で出す（押せば進む）。 */
    const initSlides = () => {
      document.querySelectorAll('[data-bx-fade]:not([data-bx-ready])').forEach((root) => {
        root.setAttribute('data-bx-ready', 'true');
        const slides = Array.from(root.querySelectorAll('[data-bx-fade-slide]'));
        const btn = root.querySelector('[data-bx-fade-toggle]');
        if (slides.length < 2) {
          if (btn) btn.hidden = true;
          return;
        }
        const interval = Math.max(2000, Number(root.dataset.interval) || 3000);
        let index = Math.max(0, slides.findIndex((el) => el.classList.contains('is-active')));
        let timer = null;
        let visible = !('IntersectionObserver' in window);
        let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        let prevTimer = null;
        const show = (next) => {
          const prev = slides[index];
          slides.forEach((el) => el.classList.remove('is-prev'));
          prev.classList.add('is-prev');
          prev.classList.remove('is-active');
          prev.setAttribute('aria-hidden', 'true');
          index = (next + slides.length) % slides.length;
          slides[index].classList.add('is-active');
          slides[index].removeAttribute('aria-hidden');
          /* フェードが終わったら前の写真を下ろす（間隔は 2 秒以上なので次の切り替えより先に終わる） */
          clearTimeout(prevTimer);
          prevTimer = setTimeout(() => prev.classList.remove('is-prev'), 1100);
        };

        const sync = () => {
          const run = visible && !paused && !document.hidden && root.isConnected;
          if (run && !timer) {
            timer = setInterval(() => {
              /* テーマエディタでセクションが描き直されると古い枠は外れる。外れたら止める */
              if (!root.isConnected) {
                clearInterval(timer);
                timer = null;
                return;
              }
              show(index + 1);
            }, interval);
          } else if (!run && timer) {
            clearInterval(timer);
            timer = null;
          }
          root.classList.toggle('is-paused', paused);
          if (btn) btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
        };

        if (btn) {
          btn.addEventListener('click', () => {
            paused = !paused;
            sync();
          });
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            for (const e of entries) visible = e.isIntersecting;
            sync();
          }).observe(root);
        }
        document.addEventListener('visibilitychange', sync);
        sync();
      });
    };

    const initAll = () => {
      initChips();
      initSlides();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-pdp-kv"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* ==========================================================================================
       BOXIV PDP KV rig.

       Shopify concatenates every section's javascript block into ONE bundle that runs on EVERY
       page, so this whole module must be inert when no [data-bx-kv] is present, and every rig
       must be fully destroyable — the Theme Editor fires shopify:section:load/unload repeatedly
       and stacked rAF loops would be permanent.
       ========================================================================================== */

    const rigs = new Map(); // root element -> rig
    const reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

    const DEADBAND = 0.016; // ~half a frame at 30fps — below this, snap and stop the loop
    const PROBE_N = 6; // seeks measured before judging the device
    const PROBE_BUDGET_MS = 90; // mean seek latency above which we abandon scrubbing

    const clamp = (v, lo, hi) => (v < lo ? lo : v > hi ? hi : v);

    const hexToRgb = (hex) => {
      const h = String(hex || '')
        .trim()
        .replace('#', '');
      if (h.length === 3) {
        return [parseInt(h[0] + h[0], 16), parseInt(h[1] + h[1], 16), parseInt(h[2] + h[2], 16)];
      }
      if (h.length >= 6) {
        return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
      }
      return null;
    };

    const mixRgb = (a, b, t) =>
      `rgb(${Math.round(a[0] + (b[0] - a[0]) * t)}, ${Math.round(a[1] + (b[1] - a[1]) * t)}, ${Math.round(
        a[2] + (b[2] - a[2]) * t
      )})`;

    /* Capability gate. saveData / very slow links → do not play at all (startLoad never fetches
       the clip for them). Weak CPU or RAM → still show motion, but via play-through rather than
       by asking the decoder for random access. */
    const gate = () => {
      const c = navigator.connection || {};
      const et = c.effectiveType || '';
      if (c.saveData === true || et === 'slow-2g' || et === '2g') return 'static';
      if (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory > 0 && navigator.deviceMemory <= 2) {
        return 'play';
      }
      if (
        typeof navigator.hardwareConcurrency === 'number' &&
        navigator.hardwareConcurrency > 0 &&
        navigator.hardwareConcurrency <= 2
      ) {
        return 'play';
      }
      return 'scrub';
    };

    const setup = (root) => {
      const track = root.querySelector('[data-bx-kv-track]');
      const stage = root.querySelector('[data-bx-kv-stage]');
      const video = root.querySelector('[data-bx-kv-video]');
      if (!track || !stage) return;

      root.setAttribute('data-bx-ready', 'true');

      const rig = {
        root,
        track,
        stage,
        video,
        raf: 0,
        destroyed: false,
        cleanups: [],
        // Mirror whatever the parse-time picker already committed to the DOM, so setMode()
        // compares against the truth and we never re-write an attribute that is already right.
        mode: root.getAttribute('data-bx-kv-mode') || 'static',
        near: false,
        pinned: false,
        scrollBound: false,
        wantPlay: false,
        playPending: false,
        primed: false,
        needsMeasure: true,
        headPx: -1,
        fill: -1,
        cur: 0,
        dur: 0,
        mediaFailed: false,
        pick: '', // source chosen but not yet assigned (see startLoad)
        metaTimer: 0,
        lerp: 0.16,
        seekStart: 0,
        seenSeeks: 0,
        probes: 0,
        probeSum: 0,
        lastP: -1,
        ambT: -1, // last ambient mix written (0 = colour A, 1 = colour B); -1 = never written
        held: [],
      };
      rigs.set(root, rig);

      const damp = parseFloat(root.dataset.bxKvDamp);
      if (!Number.isNaN(damp)) rig.lerp = clamp(damp / 100, 0.05, 0.4);

      const on = (el, type, fn, opts) => {
        el.addEventListener(type, fn, opts);
        rig.cleanups.push(() => el.removeEventListener(type, fn, opts));
      };

      /* ---------------------------------------------------------------- ambient hand-off ---- */
      const ambA = hexToRgb(root.dataset.bxKvAmbA);
      const ambB = hexToRgb(root.dataset.bxKvAmbB);

      /* TWO writes per pass — not an arc, and nothing in the rAF loop.
         .bx-kv__stage paints an opaque full-bleed background across the whole viewport for the
         entire pinned run, and .bx-ambient is `position: fixed; z-index: -1`, so ANY colour the KV
         writes is completely occluded while the KV is pinned. A per-frame interpolated arc
         (quantised steps + a rate cap + a "one more write owed" flag keeping the loop alive) was
         therefore pure cost for zero observable effect. What IS observable is the hand-off at each
         end of the run — the colour the page carries into the sections below — so that is all we
         write: colour A when the KV takes the viewport, colour B when it gives it back after the
         run completes. .bx-ambient__blob's `transition: background-color 1.6s ease` turns each
         single write into a fade for free, which is why no interpolation is needed here at all.

         The layer is re-queried per call (a handful of times per pass, so the cost is nil) rather
         than captured in setup(): editing the AMBIENT section in the Theme Editor replaces that
         node without destroying this rig (destroyWithin only matches the KV root), and a cached
         reference would go on writing to a detached element for the rest of the session. */
      const setAmbient = (t) => {
        if (!ambA || !ambB || t === rig.ambT) return;
        const layer = document.querySelector('[data-bx-ambient-layer]');
        if (!layer) return;
        rig.ambT = t;
        layer.style.setProperty('--bx-amb-a', mixRgb(ambA, ambB, t));
        layer.style.setProperty('--bx-amb-b', mixRgb(ambA, ambB, clamp(t + 0.35, 0, 1)));
        layer.style.setProperty('--bx-amb-c', mixRgb(ambA, ambB, clamp(t + 0.7, 0, 1)));
      };

      /* Release the ambient layer on teardown so boxiv-pdp-ambient.liquid owns it again. */
      rig.cleanups.push(() => {
        const layer = document.querySelector('[data-bx-ambient-layer]');
        if (!layer) return;
        layer.style.removeProperty('--bx-amb-a');
        layer.style.removeProperty('--bx-amb-b');
        layer.style.removeProperty('--bx-amb-c');
      });

      /* ------------------------------------------------------------------ playback safety ---- */
      // A source actually handed to the element — as opposed to rig.pick, one still waiting for
      // startLoad(). currentSrc is populated a task later than src, hence both.
      const assigned = () => !!(rig.video && (rig.video.currentSrc || rig.video.src));

      /* play() returns a Promise. pause() is only ever reached when no play() is in flight —
         the promise handler re-enters sync() and performs the pause there instead. */
      const sync = () => {
        const v = rig.video;
        if (!v || rig.playPending) return;
        if (rig.wantPlay) {
          // Nothing to play before startLoad() assigns the source, and play() on an empty element
          // would park a promise that the later load rejects — leaving 'play' mode stuck paused.
          // startLoad() re-enters sync() once there is something to play.
          if (!v.paused || !assigned()) return;
          const pr = v.play();
          if (pr && typeof pr.then === 'function') {
            rig.playPending = true;
            pr.then(() => {
              rig.playPending = false;
              if (rig.destroyed) {
                try {
                  v.pause();
                } catch (e) {
                  /* noop */
                }
              } else {
                sync();
              }
            }).catch(() => {
              rig.playPending = false; // autoplay blocked / element torn down — stay paused
            });
          }
        } else if (!v.paused) {
          v.pause();
        }
      };

      /* iOS will not paint frames for a muted paused <video> that has never entered the playing
         state, so seeks appear to do nothing. Prime it once: ask to play, then immediately ask to
         stop — the stop is applied inside the play() promise handler by sync(), never synchronously. */
      const prime = () => {
        // Not before the source exists: startLoad() primes again the moment it assigns one.
        if (rig.primed || !rig.video || rig.mode !== 'scrub' || !assigned()) return;
        rig.primed = true;
        rig.wantPlay = true;
        sync();
        rig.wantPlay = false;
        // Promise path: playPending is true, so this returns immediately and the pause is done
        // by the promise handler. Pre-promise path: play() returned undefined, nothing is in
        // flight, and pausing synchronously is the legacy-correct thing to do.
        sync();
      };

      /* Competing decoder sessions stall seeks on iOS: the buy-box gallery autoplays product
         videos. Park every other <video> while the KV owns the viewport, and resume only the
         ones we actually parked. */
      const holdOthers = (hold) => {
        if (hold) {
          if (rig.held.length) return;
          document.querySelectorAll('video').forEach((v) => {
            if (v === rig.video || v.paused) return;
            rig.held.push(v);
            v.pause();
          });
        } else {
          rig.held.splice(0).forEach((v) => {
            const pr = v.play();
            if (pr && typeof pr.catch === 'function') pr.catch(() => {});
          });
        }
      };
      rig.cleanups.push(() => holdOthers(false));

      /* ---------------------------------------------------------------------- the rAF loop --- */
      const request = () => {
        if (rig.destroyed || rig.raf) return;
        rig.raf = requestAnimationFrame(frame);
      };

      function frame() {
        rig.raf = 0;
        if (rig.destroyed) return;

        /* ---------- READ (every layout query for this frame happens here) ---------- */
        const trackRect = rig.track.getBoundingClientRect();
        const stageRect = rig.stage.getBoundingClientRect();
        const stageH = stageRect.height;
        let headH = rig.headPx;
        if (rig.needsMeasure) {
          const hEl =
            document.querySelector('.section-header') ||
            document.querySelector('sticky-header') ||
            document.querySelector('.header-wrapper');
          headH = hEl ? Math.round(hEl.getBoundingClientRect().height) : 0;
        }

        /* ---------- COMPUTE (no DOM reads past this point) ---------- */
        // In static mode the track is collapsed to exactly one stage, so there is no run to
        // measure — pin progress at 0 rather than letting the degenerate divide push it to 1
        // (which would fade the overlay copy out on a page that never scrubs).
        const run = Math.max(1, trackRect.height - stageH);
        const p = rig.mode === 'static' ? 0 : clamp(-trackRect.top / run, 0, 1);

        let settled = true;
        let seekTo = null;
        if (rig.mode === 'scrub' && rig.dur > 0) {
          const target = p * rig.dur;
          const delta = target - rig.cur;
          if (Math.abs(delta) <= DEADBAND) {
            rig.cur = target;
          } else {
            rig.cur += delta * rig.lerp;
            settled = false;
          }
          // Skip the write while a seek is in flight: queued seeks are coalesced anyway and the
          // in-flight one self-throttles us to whatever the decoder can actually deliver.
          if (!rig.video.seeking && Math.abs(rig.cur - rig.video.currentTime) > DEADBAND * 0.5) {
            seekTo = rig.cur;
          }
        }

        const pRound = Math.round(p * 100) / 100;

        /* ---------- WRITE ---------- */
        if (rig.needsMeasure) {
          rig.needsMeasure = false;
          if (headH !== rig.headPx) {
            rig.headPx = headH;
            rig.root.style.setProperty('--bx-kv-head', headH + 'px');
          }
          /* How far a contained 1:1 frame has to scale up to span the stage's full width.
             CSS cannot derive this — calc() will not divide a length by a length — so it is
             published here as a plain number for the intro zoom to interpolate against.
             Only changes on resize, and it is 1 on any portrait stage (there the contained
             side already IS the width), which is what disables the zoom on phones. */
          const fill = stageH > 0 ? stageRect.width / Math.min(stageRect.width, stageH) : 1;
          const fillR = Math.round(fill * 1000) / 1000;
          if (fillR !== rig.fill) {
            rig.fill = fillR;
            rig.root.style.setProperty('--bx-kv-fill', String(fillR));
          }
        }
        if (pRound !== rig.lastP) {
          rig.lastP = pRound;
          rig.root.style.setProperty('--bx-kv-p', String(pRound));
        }
        if (seekTo !== null) {
          rig.seekStart = performance.now();
          try {
            rig.video.currentTime = seekTo;
          } catch (e) {
            rig.seekStart = 0; // not seekable yet
          }
        }
        /* The two ambient writes (see setAmbient): colour A for the run, colour B once it is
           essentially over. Driven from here and not from the IntersectionObserver's un-pin,
           because the section BELOW the KV becomes the ambient engine's active target at almost
           exactly the moment the stage un-pins — a write racing that one would leave the KV's
           colour parked on a section that no longer owns it. At p >= 0.98 the stage still covers
           the viewport, so the hand-off is ordered A -> B -> next section. setAmbient() returns
           immediately unless the value actually changes, so this stays two writes per pass and
           never keeps the loop alive for an extra frame the way the old arc did. */
        if (rig.pinned) setAmbient(p >= 0.98 ? 1 : 0);

        /* Metadata never arrived (see metaTimer): the scrub track is a tall strip of dead scroll.
           Collapse it, but only while the run is at its very top so the reflow cannot yank the
           page out from under a visitor mid-scroll. Re-tested here every frame rather than once
           inside the timeout, so the rescue still lands for someone who had already scrolled when
           the timer fired — previously that visitor was left with a permanently dead track. */
        if (rig.mediaFailed && rig.mode !== 'static' && p <= 0) decideMode();

        if (!settled) request();
      }

      /* ------------------------------------------------------------------ mode management ---- */
      /* Static lays out the composed final frame (--bx-kv-out / --bx-kv-in at 1); every other mode
         opens on frame 0. Only acts when the section has a frame-0 still to swap between. Run on
         every setMode() call, not just on changes: the attribute can already read "static" (the
         Theme Editor does not run the inline picker) while the poster is still frame 0. */
      const syncPoster = (mode) => {
        const v = rig.video;
        if (!v || !v.dataset.bxKvPosterStart) return;
        const want = mode === 'static' ? v.dataset.bxKvPosterEnd : v.dataset.bxKvPosterStart;
        if (want && v.getAttribute('poster') !== want) v.setAttribute('poster', want);
      };

      const setMode = (mode) => {
        syncPoster(mode);
        if (rig.mode === mode) return;
        rig.mode = mode;
        rig.root.setAttribute('data-bx-kv-mode', mode);
        rig.needsMeasure = true;
        if (mode === 'play') {
          rig.cur = 0;
          // Rewind: pivoting out of scrub mid-run would otherwise start the play-through from
          // whatever arbitrary frame the scrub had reached.
          if (rig.video) {
            try {
              rig.video.currentTime = 0;
            } catch (e) {
              /* not seekable yet — the IO also rewinds on every exit */
            }
          }
          rig.wantPlay = rig.pinned;
        } else if (mode === 'static') {
          rig.wantPlay = false;
        }
        sync();
        request();
      };

      const pivot = () => {
        // Soft pivot: same asset, no re-render — just stop asking for random access and let the
        // clip play through on entry, which is the pattern apple.com actually ships.
        // The track collapses with the mode change (see the [data-bx-kv-mode='play'] CSS). That is
        // not a visible jump: the probe budget is spent within the first frames of scrolling, so
        // the stage is still pinned at the top of the run and only off-screen content below moves.
        if (rig.mode !== 'scrub') return;
        setMode('play');
      };

      // A real resource, or one startLoad() is guaranteed to assign. NOT data-bx-kv-src: that is
      // ALWAYS server-rendered, so accepting it as proof of a source made this function unable to
      // report "no video" — decideMode() chose 'scrub' and the visitor got a full-length track with
      // a video that never loads. rig.pick is only set when there is something to load (it already
      // reflects the breakpoint and the Data-Saver opt-out), and once it is, the load / first-scroll
      // / cap triggers below always assign it; metaTimer then covers a source that fails to load.
      const hasSrc = () => assigned() || !!rig.pick;

      const decideMode = () => {
        if (reduceMQ.matches) return setMode('static');
        if (!hasSrc() || rig.mediaFailed) return setMode('static');
        const g = gate();
        if (g === 'static') return setMode('static');
        if (g === 'play') return setMode('play');
        return setMode('scrub');
      };

      /* ------------------------------------------------------------------------- listeners --- */
      const onScroll = () => request();

      const bindScroll = (bind) => {
        if (bind === rig.scrollBound) return;
        rig.scrollBound = bind;
        if (bind) window.addEventListener('scroll', onScroll, { passive: true });
        else window.removeEventListener('scroll', onScroll);
      };
      rig.cleanups.push(() => bindScroll(false));

      const onResize = () => {
        rig.needsMeasure = true;
        request();
      };
      on(window, 'resize', onResize, { passive: true });
      on(window, 'orientationchange', onResize);

      // Armed by startLoad() when the source is assigned, not here: the clip is only requested once
      // the page has loaded, and a timer started at setup would count that wait as a dead clip.
      rig.cleanups.push(() => clearTimeout(rig.metaTimer));

      if (rig.video) {
        const onMeta = () => {
          clearTimeout(rig.metaTimer);
          const d = rig.video.duration;
          // Trim one beat off the end: p === 1 must not land past the final decodable frame.
          rig.dur = Number.isFinite(d) && d > 0 ? Math.max(0, d - 0.05) : 0;
          rig.mediaFailed = rig.dur <= 0;
          decideMode();
          request();
        };

        const onMediaError = () => {
          clearTimeout(rig.metaTimer);
          rig.mediaFailed = true;
          setMode('static');
        };

        on(rig.video, 'loadedmetadata', onMeta);
        on(rig.video, 'error', onMediaError);

        /* Catch up on a state the element reached BEFORE these listeners existed.
           The inline script used to assign v.src while the document was still parsing, but setup()
           only runs at DOMContentLoaded. On a cached clip the metadata was therefore ready long
           before the listener was attached, and 'loadedmetadata' — which fires exactly once — was
           gone for good. rig.dur then stayed 0, metaTimer declared the media dead 8 s later and
           decideMode() dropped a perfectly healthy KV into 'static', where --bx-kv-out / --bx-kv-in
           snap to 1: the frame pulled back and the outro title appeared while the visitor had not
           scrolled at all ("leave it alone for ~10 s and the intro zoom suddenly collapses").
           startLoad() now assigns the source after these listeners exist, so this should never
           fire — it stays as the guard for any path that hands the element a source earlier. */
        if (rig.video.error) onMediaError();
        else if (rig.video.readyState >= 1 /* HAVE_METADATA */) onMeta();

        on(rig.video, 'seeked', () => {
          const started = rig.seekStart;
          rig.seekStart = 0;
          if (!started || rig.mode !== 'scrub') return;
          rig.seenSeeks += 1;
          if (rig.seenSeeks === 1) return; // first seek carries buffering cost — not a signal
          if (rig.probes >= PROBE_N) return;
          rig.probes += 1;
          rig.probeSum += performance.now() - started;
          if (rig.probes >= PROBE_N && rig.probeSum / rig.probes > PROBE_BUDGET_MS) pivot();
        });
      }

      const onReduceChange = () => {
        if (reduceMQ.matches) setMode('static');
        else {
          startLoad(); // reduced motion skipped the fetch; motion is back on, so fetch now
          decideMode();
        }
      };
      if (typeof reduceMQ.addEventListener === 'function') {
        on(reduceMQ, 'change', onReduceChange);
      }

      /* Visibility drives everything: the scroll listener is only attached while the stage is
         anywhere near the viewport, so the KV adds nothing to the global scroll cost elsewhere
         on the page (boxiv-mega-nav already reads getBoundingClientRect on every scroll < 990px). */
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              rig.near = entry.isIntersecting;
              const pinned = entry.intersectionRatio >= 0.6;
              if (pinned !== rig.pinned) {
                rig.pinned = pinned;
                holdOthers(pinned);
                if (rig.mode === 'play') {
                  rig.wantPlay = pinned;
                  sync();
                }
              }
              if (rig.near) {
                rig.needsMeasure = true;
                prime();
                bindScroll(true);
                request();
              } else {
                bindScroll(false);
                if (rig.raf) {
                  cancelAnimationFrame(rig.raf);
                  rig.raf = 0;
                }
                if (rig.mode === 'play' && rig.video) {
                  rig.wantPlay = false;
                  sync();
                  try {
                    rig.video.currentTime = 0; // rewind so re-entry replays from the top
                  } catch (e) {
                    /* noop */
                  }
                }
              }
            });
          },
          { threshold: [0, 0.6] }
        );
        io.observe(rig.stage);
        rig.cleanups.push(() => io.disconnect());
      } else {
        // No IntersectionObserver: nothing will ever toggle these, so assume the rig owns the
        // viewport. Without pinned = true the ambient hand-off and 'play' mode never start.
        rig.near = true;
        rig.pinned = true;
        bindScroll(true);
      }

      rig.destroy = () => {
        if (rig.destroyed) return;
        rig.destroyed = true;
        if (rig.raf) cancelAnimationFrame(rig.raf);
        rig.raf = 0;
        rig.wantPlay = false;
        rig.cleanups.splice(0).forEach((fn) => {
          try {
            fn();
          } catch (e) {
            /* noop */
          }
        });
        // Safe: if a play() promise is still in flight its handler performs the pause instead.
        if (!rig.playPending && rig.video && !rig.video.paused) {
          try {
            rig.video.pause();
          } catch (e) {
            /* noop */
          }
        }
        rigs.delete(root);
        root.removeAttribute('data-bx-ready');
      };

      /* ------------------------------------------------------------------ deferred source --- */
      /* The rig is the ONLY thing that assigns video.src (the inline script just picks the mode).
         One <video> element / one decoder session per breakpoint: <source media> is not honoured
         for video, so the breakpoint is resolved here. The media listeners above are already
         attached, so the assignment always delivers loadedmetadata/error to this rig.

         It waits for the page's `load` and then an idle slot, so the 4.3MB clip stops competing
         with everything the first paint and the buy box need (see the comment on the inline
         script). The first sign that the visitor is about to scroll — the only moment the clip
         is actually needed — overrides the wait, and so does a cap for pages whose `load` is held
         back indefinitely by a slow third-party resource. Until then the poster stands in for
         frame 0, and the CSS-driven parts of the run (zoom, pull-back, outro) work without it. */
      if (rig.video && !assigned()) {
        const conn = navigator.connection;
        if (conn && conn.saveData) {
          rig.video.preload = 'none'; // Data Saver: poster only, never fetch the clip
        } else {
          const d = rig.video.dataset;
          const mobile = window.matchMedia('(max-width: 749px)').matches;
          rig.pick = (mobile && d.bxKvSrcMobile) || d.bxKvSrc || d.bxKvSrcMobile || '';
        }
      }

      function startLoad() {
        // Static visitors never need the clip; onReduceChange() calls back in if that changes.
        if (rig.destroyed || !rig.pick || reduceMQ.matches || gate() === 'static') return;
        const v = rig.video;
        v.muted = true; // attribute alone is not always enough for programmatic play()
        v.playsInline = true;
        v.src = rig.pick;
        rig.pick = '';
        // If metadata never arrives the track would be a tall strip of dead scroll. Flag it and
        // wake the loop: the collapse itself happens in frame(), which re-checks the condition
        // every frame and fires the moment the run is back at its top (p === 0). Deciding here and
        // only here would strand anyone who had already scrolled when the timeout fired.
        rig.metaTimer = setTimeout(() => {
          if (rig.dur > 0 || rig.destroyed) return;
          rig.mediaFailed = true;
          request();
        }, 8000);
        if (rig.near) prime();
        sync(); // 'play' mode may already want to play
      }

      if (rig.pick) {
        if (window.Shopify && window.Shopify.designMode) {
          startLoad(); // the Theme Editor: no first paint to protect, show the edit at once
        } else {
          // wheel / touchstart arrive a beat before the first scroll event; scroll covers the rest
          // (keyboard, scrollbar, restored scroll position).
          ['scroll', 'wheel', 'touchstart'].forEach((type) =>
            on(window, type, startLoad, { passive: true, once: true })
          );
          const afterLoad = () => {
            if (typeof window.requestIdleCallback === 'function') {
              window.requestIdleCallback(startLoad, { timeout: 2000 });
            } else {
              setTimeout(startLoad, 200); // Safari has no requestIdleCallback
            }
          };
          if (document.readyState === 'complete') afterLoad();
          else on(window, 'load', afterLoad, { once: true });
          const cap = setTimeout(startLoad, 8000);
          rig.cleanups.push(() => clearTimeout(cap));
        }
      }

      decideMode();
      request();
    };

    const initKv = () => {
      document.querySelectorAll('[data-bx-kv]:not([data-bx-ready])').forEach(setup);
    };

    /* Covers both directions: on unload the section may already be detached (document.contains
       is false), and on reload it is still in the tree but inside the replaced container. */
    const destroyWithin = (container) => {
      Array.from(rigs.values()).forEach((rig) => {
        if (typeof rig.destroy !== 'function') return;
        if (!document.contains(rig.root) || (container && container.contains && container.contains(rig.root))) {
          rig.destroy();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKv);
    } else {
      initKv();
    }

    document.addEventListener('shopify:section:unload', (e) => destroyWithin(e.target));
    document.addEventListener('shopify:section:load', (e) => {
      destroyWithin(e.target);
      initKv();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxiv-pdp-recommends"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__bxRecsInit) return;
    window.__bxRecsInit = true;

    // Recommendation cards are injected asynchronously, so arrow controls use a single
    // delegated listener that survives the swap.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bx-rec-prev], [data-bx-rec-next]');
      if (!btn) return;
      const pr = btn.closest('.bx-recs__pr');
      const track = pr && pr.querySelector('[data-bx-rec-track]');
      if (!track) return;
      const card = track.querySelector('.bx-recs__card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: btn.matches('[data-bx-rec-next]') ? step : -step, behavior: 'smooth' });
    });

    // Dawn's <product-recommendations> fetches once with no retry; a transient failure
    // leaves the carousel empty. Re-fetch (a few times, backed off) if still empty.
    const fill = (pr) => {
      if (pr.querySelector('.bx-recs__card')) return;
      const tries = parseInt(pr.dataset.bxTries || '0', 10);
      if (tries >= 6) return;
      pr.dataset.bxTries = String(tries + 1);
      fetch(`${pr.dataset.url}&product_id=${pr.dataset.productId}&section_id=${pr.dataset.sectionId}`, { cache: 'no-store' })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((text) => {
          const div = document.createElement('div');
          div.innerHTML = text;
          const inner = div.querySelector('product-recommendations');
          if (inner && inner.innerHTML.trim().length) {
            pr.innerHTML = inner.innerHTML;
          } else {
            throw new Error('empty');
          }
        })
        .catch(() => {
          setTimeout(() => fill(pr), 1200 * (tries + 1));
        });
    };

    const watch = () => {
      document.querySelectorAll('.bx-recs__pr:not([data-bx-watched])').forEach((pr) => {
        pr.setAttribute('data-bx-watched', 'true');
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              obs.unobserve(pr);
              // Let Dawn's own element try first, then backfill if it came up empty.
              setTimeout(() => fill(pr), 2000);
            });
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(pr);
        } else {
          fill(pr);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }
    document.addEventListener('shopify:section:load', watch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
